import { green, orange, red } from "@mui/material/colors";
import { relativeTime } from "common/utils";
import { Circle } from "lucide-react";
import { ReactNode } from "react";

export const calendarSyncStatus = (
  integrationStatus: "active" | "error" | "deactivated",
  lastAccessedSec: number,
  integrationType?: string,
): [ReactNode, string] => {
  let byline = "";
  let status = "";
  // Google calendars are read live on every request, so "last synced" is not meaningful
  // (lastAccessedSec is only bumped when a live read fails). Show connection state instead.
  if (integrationType === "google") {
    byline =
      integrationStatus === "error"
        ? "Disconnected — reconnect to sync"
        : "Connected";
    status = integrationStatus === "error" ? red[500] : green[500];
  } else if (Number(lastAccessedSec) === 0) {
    byline = "Never been synced";
    status = orange[500];
  } else if (
    Number(lastAccessedSec) <
    new Date().getTime() / 1000 - 60 * 60 * 25
  ) {
    byline = "Calendar has not been synced in over 24 hours";
    status = red[500];
  } else {
    byline = `Last synced ${relativeTime(
      new Date(Number(lastAccessedSec) * 1000),
    )}`;
    status = green[500];
  }
  // Color overrides.
  if (integrationStatus === "error") {
    status = red[500];
  } else if (integrationStatus === "deactivated") {
    status = orange[500];
  }
  const icon = (
    <Circle
      style={{
        height: "12px",
        width: "12px",
        fill: status,
        stroke: "none",
      }}
    />
  );
  return [icon, byline];
};
